import { createFileRoute } from "@tanstack/react-router"
import DesignSystemExpandableCard from "~/pages/design-system/components/ExpandableCard"

export const Route = createFileRoute("/_auth/internal/design-system/components/expandable-card")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemExpandableCard />
}
